import {
  GET_PARTICIPANT_ASSESSMENT,
  GET_PARTICIPANT_ASSESSMENT_RESULT,
  REDIRECT_TO,
  SET_SELECTED_ANSWER,
  RESET_REDIRECTION,
} from "../actions/actionsTypes";

const initialState = {
  redirection: {
    isRedirect: false,
    isExternalURL: false,
    redirectTo: "",
  },
  assessmentTemplate: [],
  participantAnswers: [],
  disableButtonSetPassword: false,
  participantAssessmentResult: {
    focusAreaScores: [],
    total: 0,
    updatedTotalScore: 0,
  },
};

export const initialAssessmentReducer = (state = initialState, action) => {
  if (action.type === GET_PARTICIPANT_ASSESSMENT) {
    const { assessmentTemplate } = action.payload;
    const participantAnswers = action.payload.participantAnswers
      ? action.payload.participantAnswers
      : [];
    return {
      ...state,
      assessmentTemplate,
      participantAnswers,
    };
  }

  if (action.type === GET_PARTICIPANT_ASSESSMENT_RESULT) {
    const participantAssessmentResult = action.payload;
    return {
      ...state,
      participantAssessmentResult,
      disableButtonSetPassword: true,
    };
  }
  if (action.type === REDIRECT_TO) {
    const redirection = action.payload;
    return {
      ...state,
      redirection,
    };
  }

  if (action.type === SET_SELECTED_ANSWER) {
    const { questionId, answerId } = action.payload;
    const participantAnswers = state.participantAnswers.filter(
      (question) => question.questionId !== questionId
    );
    return {
      ...state,
      participantAnswers: [...participantAnswers, { questionId, answerId }],
    };
  }
  if (action.type === RESET_REDIRECTION) {
    const { redirection } = initialState;
    return {
      ...state,
      redirection,
    };
  }

  return state;
};
